<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in icon="Q" :title="title"></SectionTitle>
    <QuestionBox :title="questionTitle" :desc="questionDesc" :items="questionItem" :index="questionAnswer" v-on:selected="selected"></QuestionBox>
    <GoNext class="animate-target" v-animate-in href="/section1/1-4" :selected="selectedValue" required="true">Submit</GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt"/>
  </div>
</template>

<script>
import QuestionBox from "../../components/QuestionBox";
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
export default {
  name: "s1-3",
  components: {SectionTitle, QuestionBox, GoNext, ContentNotice},
  data(){
    return {
      questionTitle: "Question 3",
      questionDesc: "In addition to blood glucose and blood pressure control, the guideline-recommended treatments with additional CV and renal protective benefits in patients with T2D and CKD are:",
      questionItem:[
        "SGLT2i, ACEi/ARB, nsMRA",
        "GLP-1 RA, SGLT2i, ACE/ARB",
        "ACEi/ARB, SGLT2i, nsMRA, GLP-1 RA",
        "GLP-1 RA, ACEi/ARB, nsMRA"
      ],
      selectedValue:'',
      questionAnswer:'2',
      title:'Pre-activity quiz',
      noticeTxt: 'ACEi, angiotensin-converting enzyme inhibitor; ARB, Angiotensin receptor blocker; CKD, chronic kidney disease; CV, cardiovascular disease; GLP-1 RA, glucagon-like peptide-1 receptor agonist; nsMRA, nonsteroidal mineralocorticoid receptor antagonist; RAS, Renin-angiotensin system; SGLT-2-sodium-glucose co-transporter 2; T2D, type 2 diabetes.'
    }
  },
  methods:{
    selected:function(value){
      this.selectedValue = value;
    }
  }
}
</script>

<style scoped>

</style>
